import './index.css';
import ClipLoader from "react-spinners/ClipLoader";
import React from "react";
import "./styles.css";
import "./dropdownstyles.css";
import { useTranslation } from 'react-i18next';

class SelectBox extends React.Component {
  // constructor(){
  //   super()
    
    
  // }
  
  state = {
    extravalue:this.props.extravalue,
    inputRef: React.createRef(null),
    arrowUpRef: React.createRef(null),
    arrowDownRef: React.createRef(null),
    divRef: React.createRef(null),
    items: this.props.items || [],
    itemsShow: this.props.items || [] ,
    showItems: false,
    selectedItem: this.props.defaultValue ?
    this.props.items && this.props.items.filter((item)=> {
      return item.id == this.props.defaultValue 
    }).length > 0 ? this.props.items.filter((item)=> item.id == this.props.defaultValue )[0]
      : this.props.items && this.props.items.filter((item)=> item.value == this.props.defaultValue ).length > 0 ? this.props.items.filter((item)=> item.value == this.props.defaultValue )[0]
      : typeof this.props.defaultValue === 'string' ? {'id':9999,'name':"",'value':"" } 
      : this.props.items && this.props.items[0]
    : this.props.items && this.props.items[0],
    disable:this.props.disable ? true:false,
    
  };

  selectRef = React.createRef();

  dropDown = () => {
    if(!this.props.disable){
      this.setState(prevState => ({
        showItems:!this.state.showItems
      }));
    }
    
    
  };

  focusDropdown = () => {
    this.setState(prevState => ({
      showItems: true
    }));
  }
  
  blurDropdown = (e) => {
    if(!e.currentTarget.contains(e.relatedTarget)){    
      this.setState(prevState => ({
        showItems: false
      }));
      this.setState({
        itemsShow: this.state.selectedItem ? this.props.items.filter((item) => item.value.toLowerCase().includes("")) || []: this.props.items || []
      });
      this.state.inputRef.current.value = ""
    }
    // console.log(this.state.itemsShow,"AAAAAAAAAAAA")
    
    
    
    
  }

  selectItem = item => {
    // console.log(this.props.defaultValue)
    this.setState({
      selectedItem:item,
      showItems: false
    });
    this.state.inputRef.current.value=""
    
    this.props.setBusinessSize(item.value)
    if (this.props.allvalue)
      this.props.setBusinessSize(item)
    if(this.props.extrapropertyOnDropdown || this.props.extravalue)
      this.props.setExtraValue(item[this.props.extrapropertyOnDropdown ? this.props.extrapropertyOnDropdown : this.props.extravalue])
    if(this.props.thirdPropertyOnDropdown || this.props.thirdvalue)
      this.props.setThirdValue(item[this.props.thirdPropertyOnDropdown ? this.props.thirdPropertyOnDropdown : this.props.thirdvalue])
  };

  handleChange = e => {
    this.setState({
      showItems: true
    });
    
    this.props.setQuery(e.target.value)
    this.setState({
      
      // selectedItem:e.target.value,
      itemsShow: this.state.selectedItem ? this.props.items.filter((item) => item.value.toLowerCase().includes(e.target.value.toLowerCase())) || []: this.props.items || []
    });
    
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.items !== prevProps.items){
      
        this.setState(prevState => ({
          itemsShow: this.props.items
        }));
    }
    if (this.props.defaultValue !== prevProps.defaultValue) {
      

      this.setState(prevState => ({
        
        selectedItem: this.props.defaultValue ? 
        this.props.items && this.props.items.filter((item)=> item.value == this.props.defaultValue ).length > 0 ? this.props.items.filter((item)=> item.value == this.props.defaultValue )[0]
          : this.props.items && this.props.items.filter((item)=> item.id == this.props.defaultValue ).length > 0 ? this.props.items.filter((item)=> item.id == this.props.defaultValue )[0]
          : typeof this.props.defaultValue === 'string' ? {'id':9999,'name':"",'value':"" } 
          : this.props.items && this.props.items[0]
        : this.props.items && this.props.items[0]
      }))
    }
  }

  render() {
    return (
      
      <div ref={this.state.divRef} className="select-box--box"
        tabIndex={"-1"}
        // onFocus={this.focusDropdown}
        style={this.props.disable ? {opacity:"0.5"}:{opactiy:"1"}}
        onBlur={(e) => this.blurDropdown(e)}>
        <div className="select-box--container">
          <div className="select-box--selected-item" onClick={
                        () => {
                          if(!this.props.disable){
                            this.setState(prevState => ({
                              showItems: !prevState.showItems
                            }));
                          }
                          
                          this.state.inputRef.current.focus()
                        }
                }>
            <input ref={this.state.inputRef} type="text" /*value={this.state.selectedItem.value}*/ 
              placeholder={this.state.selectedItem ?  
                (this.props.allvalue ? this.props.defaultValue[this.props.allvalueproperty]:this.props.defaultValue)
                : this.state.selectedItem.value}
              onChange={(e)=> this.handleChange(e)} 
              disabled={this.props.disable}
              />
            {
                    this.props.loading == "load" ? <div className="companydetail__delete" style={{
                        position:"absolute",
                        width:"20px",
                        backgroundImage:"none",
                        left:"90%"
                    }}>
                      
                        <ClipLoader color="#F2F8F0" size={20} /></div> 
                    :null
            }
              <button ref={this.state.arrowUpRef} className="select-box--arrow" >
                <span 
                  className={`${ this.state.showItems ?
                    "select-box--arrow-up":
                    "select-box--arrow-down"
                  }`}
                />
              </button>
          </div>
          

          <div
            style={{ display: this.state.showItems ? "block" : "none" ,
              width:this.state.divRef.current ? (Math.min(this.state.divRef.current.clientWidth *2,400) + "px"): "0px",
              left:this.state.divRef.current ? this.state.divRef.current.offsetLeft - this.props.scrollLeft+ "px":"asd"}}
            className={"select-box--items"}
          >
            {
              this.state.itemsShow.map((item,i) => {
                {/* console.log(item,i) */}
                return <div
                    // key={item.id}
                    onClick={() => {
                      // console.log(this.state.itemsShow,item,"AAAAAAAAAAAA")
                      this.selectItem(item)
                      this.setState({
                        itemsShow: this.state.selectedItem ? this.props.items.filter((item) => item.value.toLowerCase().includes("")) || []: this.props.items || []
                      });
                      this.state.inputRef.current.value = ""
                    }}
                    className={this.state.selectedItem === item ? "selected" : ""}
                    // key={i}
                  >
                    {item.value}
                  </div>
              })
            }
          </div>
        </div>
      </div>
    );
  }
}


const Dropdown = ({result="Choose One",list,setBusinessSize,setExtraValue,setThirdValue
  ,styleNo,withBackground,query,setQuery,extravalue,thirdvalue,
  loading,setLoading,disable,scrollLeft,extrapropertyOnDropdown,thirdPropertyOnDropdown,allvalue=false,allvalueproperty}) => {
    const { t } = useTranslation();
    return ( 
        <div className={"azilisdropdown " + "dropdown__style"+styleNo + (withBackground ? " __background__":"")}  >
            <div style={{ position: "relative" }} />
            <SelectBox
            defaultValue={result ? result : t('CHOOSE_ONE')}
            items={list}
            setExtraValue={setExtraValue ?setExtraValue : function(){return;}}
            setThirdValue={setThirdValue ? setThirdValue : function() {return;}}
            setBusinessSize={setBusinessSize}
            extravalue={extravalue}
            extrapropertyOnDropdown={extrapropertyOnDropdown}
            thirdvalue={thirdvalue}
            thirdPropertyOnDropdown={thirdPropertyOnDropdown}
            query={query}
            setQuery={setQuery}
            loading={loading}
            setLoading={setLoading}
            disable={disable}
            scrollLeft={scrollLeft}
            allvalue={allvalue}
            allvalueproperty={allvalueproperty}
            />
        </div>
     );
}
 
export default Dropdown;